import { render, staticRenderFns } from "./Teen5.vue?vue&type=template&id=4470d95b&scoped=true&"
import script from "./Teen5.vue?vue&type=script&lang=js&"
export * from "./Teen5.vue?vue&type=script&lang=js&"
import style0 from "./Teen5.vue?vue&type=style&index=0&id=4470d95b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4470d95b",
  null
  
)

export default component.exports